import { GitBranch, ArrowUpRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import type { SideJobReport } from '../lib/sideJobReport'
import MarkdownBody from './MarkdownBody'

export default function SideJobReportBody({ report }: { report: SideJobReport }) {
  return (
    <div className="max-w-prose space-y-2">
      <h3 className="flex flex-wrap items-center gap-x-2 gap-y-1 font-semibold text-teal-900 dark:text-teal-100">
        <GitBranch className="h-4 w-4 shrink-0" aria-hidden="true" />
        {report.kind === 'formatted' ? report.agent : 'Side job report'}
        {report.kind === 'formatted' && (
          <span className={report.outcome === 'failed' ? 'text-red-700 dark:text-red-300' : 'font-normal'}>
            · {report.outcome === 'failed' ? 'Failed' : 'Finished'}
          </span>
        )}
      </h3>
      {report.kind === 'formatted' && <p className="font-medium">{report.title}</p>}
      {report.kind === 'formatted' && report.summary ? (
        <MarkdownBody body={report.summary} />
      ) : (
        <p>{report.kind === 'formatted' && report.outcome === 'failed'
          ? 'The agent stopped with a failure. See the full report for what remains.'
          : 'Full results are available below.'}</p>
      )}
      <div className="flex flex-wrap items-start gap-x-4">
        {report.kind === 'formatted' && (
          <Link
            to={report.topicPath}
            className="inline-flex min-h-11 items-center gap-1 font-medium text-teal-800 underline underline-offset-4 dark:text-teal-200 rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600"
          >
            Open side chat <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        )}
        <details className="w-full">
          <summary className="flex min-h-11 cursor-pointer items-center font-medium text-teal-800 underline underline-offset-4 dark:text-teal-200 rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600">
            Full report
          </summary>
          <MarkdownBody body={report.body} />
        </details>
      </div>
    </div>
  )
}
